
<ng-container *ngIf="{ onInit: onInit$ | async, menuReady: menuReady$ | async, menusSede: menusSede$ | async } as data">
	<!-- Header de la sección menú comedor -->
	<div class="info-header">
		<div class="info-header__icon menu__icon"></div>
		<div class="info-header__title">Menú comedor</div>
		<div class="info-header__util">
			<ng-container *ngIf="data.menuReady; else loadingMenu">
				<div class="refresh__icon" (click)="onRefreshMenu()" gtagEvent="recargar" gtagCategory="menú-del-día-widget"></div>
			</ng-container>
		</div>
	</div>

	<!-- Menúes -->
	<div class="info-content-container">
		<div class="menu__tab">
			<ul ngbNav #menuTab="ngbNav" [activeId]="sedeSelected" (navChange)="onNavChanged( $event )" class="nav-tabs">
				<!-- Menu Sede -->
				<li *ngFor="let sede of MENU_COMEDOR_SEDES" [ngbNavItem]="sede">
					<a ngbNavLink>{{ MENU_SEDE_TITLES[ sede ] }}</a>
					<ng-template ngbNavContent>
						<ng-container [ngTemplateOutlet]="menu" [ngTemplateOutletContext]="{ onInit: data.onInit, menuSede: data?.menusSede( sede ), sede: sede }"></ng-container>
					</ng-template>
				</li>
			</ul>

			<div [ngbNavOutlet]="menuTab"></div>
		</div>
	</div>
</ng-container>


<!-- Menu template -->
<ng-template #menu let-onInit="onInit" let-menuSede="menuSede" let-sede="sede">
	<ng-container *ngIf="!onInit && isMenuEmpty( menuSede?.menu )">
		<div class="empty__menu">El menú no está disponible.</div>
	</ng-container>
	<ng-container *ngIf="!isMenuEmpty( menuSede?.menu )">

		<!-- Turno (almuerzo/cena) y fecha completa  -->
		<div class="menu-turno" [ngClass]="menuSede.status.turno == ALMUERZO? 'turno-almuerzo': 'turno-cena'">
			<div>
				<div class="turno-icon" [ngClass]="menuSede.status.turno == ALMUERZO? 'almuerzo-icon': 'cena-icon'"></div>
			</div>
			<div>
				<div class="turno">{{ MENU_COMEDOR_TURNO_TITLES[ menuSede.status.turno ] }}</div>
				<div>{{ menuSede.menu.fechaAsString }}</div>
			</div>
		</div>

		<!-- Opciones del menu -->
		<ng-container *ngFor="let menuPart of MENU_COMEDOR_OPCIONES">
			<div *ngIf="menuSede.menu[menuPart] && menuSede.menu[menuPart].length > 0" class="info-content">
				<div class="menu__data">
					<div class="menu-opcion__icon-container">
						<div class="menu-opcion__icon" [ngClass]="menuPart + '__icon'"></div>
					</div>
					<div class="menu__titulo">{{ MENU_COMEDOR_TITLES[menuPart] }}</div>

					<ng-container *ngFor="let opcion of menuSede.menu[menuPart]">
						<div class="menu__bullet"></div>
						<div *ngIf="opcion; else emptyMenuOpcion" class="menu__opcion">{{ opcion }}</div>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</ng-container>

	<!-- Sugerencias -->
	<div class="info-link" [managedLink]="MENU_SUGERENCIAS[ sede ]" gtagEvent="{{sede}} + '-sugerencias'" gtagCategory="menu-del-día-widget">Ingresar sugerencias</div>
</ng-template>


<!-- Loading menu template -->
<ng-template #loadingMenu>
	<div class="loading__icon spinner-border text-info"></div>
</ng-template>